// User reducer types
export const UPDATED_SAVED_LIST = 'UPDATED_SAVED_LIST';
export const DELETED_SAVED_LIST = 'DELETED_SAVED_LIST';
export const ADD_TRACK_TO_SAVED_LIST = 'ADD_TRACK_TO_SAVED_LIST';
export const REMOVE_TRACK_FROM_SAVED_LIST = 'REMOVE_TRACK_FROM_SAVED_LIST';

export const ADD_SPEAKER_SUBSCRIBE_IDS = 'ADD_SPEAKER_SUBSCRIBE_IDS';
export const FOR_ME_LOADING_COUNT_INCREASE = 'FOR_ME_LOADING_COUNT_INCREASE';
export const FOR_ME_LOADING_COUNT_DECREASE = 'FOR_ME_LOADING_COUNT_DECREASE';
export const FOR_ME_LOAD_FAILED = 'FOR_ME_LOAD_FAILED';
export const FOR_ME_PREFERENCE_SAVE_STARTED = 'FOR_ME_PREFERENCE_SAVE_STARTED';
export const FOR_ME_PREFERENCE_SAVE_FINISHED = 'FOR_ME_PREFERENCE_SAVE_FINISHED';
export const FOR_ME_PREFERENCE_REFRESH_REQUESTED = 'FOR_ME_PREFERENCE_REFRESH_REQUESTED';
export const FOR_ME_PREFERENCE_REFRESH_READY = 'FOR_ME_PREFERENCE_REFRESH_READY';
export const FOR_ME_PREFERENCE_REFRESH_FAILED = 'FOR_ME_PREFERENCE_REFRESH_FAILED';
export const FOR_ME_PREFERENCE_REFRESH_APPLIED = 'FOR_ME_PREFERENCE_REFRESH_APPLIED';
export const FOR_ME_PREVIEW_SEEN = 'FOR_ME_PREVIEW_SEEN';
export const LOAD_LATEST_SUBSCRIED = 'LOAD_LATEST_SUBSCRIED'
export const LATEST_SUBSCRIBED_LOAD_FAILED = 'LATEST_SUBSCRIBED_LOAD_FAILED';
export const INVALIDATE_LATEST_SUBSCRIBED = 'INVALIDATE_LATEST_SUBSCRIBED';
export const LOAD_RECENTLY_PLAYED = 'LOAD_RECENTLY_PLAYED'
export const LOAD_RECENTLY_SAVED = 'LOAD_RECENTLY_SAVED'
export const SAVE_TRACK_MUTATION_FINISHED = 'SAVE_TRACK_MUTATION_FINISHED';
export const SAVE_TRACK_MUTATION_STARTED = 'SAVE_TRACK_MUTATION_STARTED';
export const LOAD_TOPIC_PREFERENCES = 'LOAD_TOPIC_PREFERENCES';
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED';
export const SET_AUTH_RESTORE_ERROR = 'SET_AUTH_RESTORE_ERROR';
export const SET_FOR_ME = 'SET_FOR_ME';
export const SET_GET_STARTED_TOPICS_STATUS_TRUE = 'SET_GET_STARTED_TOPICS_STATUS_TRUE';
export const SET_LATEST_SUBSCRIED = 'SET_LATEST_SUBSCRIED';
export const SET_PODCAST_SUBSCRIBE_STATUS = 'SET_PODCAST_SUBSCRIBE_STATUS';
export const SET_RECENTLY_PLAYED = 'SET_RECENTLY_PLAYED';
export const SET_RECENTLY_SAVED = 'SET_RECENTLY_SAVED';
export const SET_SPEAKER_SUBSCRIBE_STATUS = 'SET_SPEAKER_SUBSCRIBE_STATUS';
export const SYNC_SUBSCRIBE_STATUSES = 'SYNC_SUBSCRIBE_STATUSES';
export const SET_SAVE_TRACK_STATUS = 'SET_SAVE_TRACK_STATUS';
export const SET_UNAUTHENTICATED = 'SET_UNAUTHENTICATED';
export const SET_USER = 'SET_USER';
export const SYNC_TOPIC_PREFERENCES = 'SYNC_TOPIC_PREFERENCES';
export const TOPIC_PREFERENCE_MUTATION_FINISHED = 'TOPIC_PREFERENCE_MUTATION_FINISHED';
export const TOPIC_PREFERENCE_MUTATION_ROLLED_BACK = 'TOPIC_PREFERENCE_MUTATION_ROLLED_BACK';
export const TOPIC_PREFERENCE_MUTATION_STARTED = 'TOPIC_PREFERENCE_MUTATION_STARTED';
export const TOPIC_PREFERENCES_LOAD_FAILED = 'TOPIC_PREFERENCES_LOAD_FAILED';
export const TOPIC_PREFERENCES_LOADED = 'TOPIC_PREFERENCES_LOADED';

// Data reducer types
export const SET_NEXT_PREVIEWS_INFO = 'SET_NEXT_PREVIEWS_INFO';
export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';
export const SET_SPEAKER_TOPICS = 'SET_SPEAKER_TOPICS';
export const SET_TRACK = 'SET_TRACK';
